/* eslint-disable react-hooks/exhaustive-deps */
import {
    Button,
    Card,
    Col,
    Form,
    Input,
    Row,
    Tabs,
  } from "antd";
  import "./style.css";
  import { LockOutlined } from "@ant-design/icons";
  import { useDispatch, useSelector } from "react-redux";
  import { State } from "../../../model/application/state";
  import { useCallback } from "react";
  import { MerchantSetting } from "../../../service/action/merchant";
  import { MerchantLayoutContainer } from "../../../shared/layout/MerchantLayoutContainer";
  import { AiTwotoneLock } from "react-icons/ai";
  import { APIrequest } from "../../../model/client/request";
  
  const UserSettings = () => {
    const dispatch = useDispatch();
    const { merchantSettings, apiLoaderState }: any = useSelector((state) => state);
    const state: State.MerchantSettings = merchantSettings;
    const api: State.APILoader = apiLoaderState
  
    const SetRequest = useCallback(
      (
        state: State.MerchantSettings,
        value: any,
        key: keyof APIrequest.ChangeTransactionPin
      ) => {
        dispatch({
          type: MerchantSetting.Set_Merchant_KeySettings_State,
          payload: {
            ...state,
            changePin: {
              ...state.changePin,
              [key]: value,
            },
          },
        });
      },
      [state]
    );
  
    const onFinish = useCallback(
      (state: State.MerchantSettings) => {
        dispatch({
          type: MerchantSetting.Change_Pin,
          payload: {
            ...state
          }
        })
      },
      [state],
    )
    
    const ResetPin = useCallback(
      () => {
        dispatch({
          type: MerchantSetting.Reset_Pin,
          payload: {
            ...state
          }
        })
      },
      [state],
    )
  
    return (
      <MerchantLayoutContainer defaultSelectedKeys="100" pageTitle="Settings">
        <div className="tabs" data-aos="zoom-in-up">
          <Tabs
            defaultActiveKey="1"
            items={[
              {
                key: "3",
                label: (
                  <span className="tab-pane">
                    <LockOutlined rev={undefined} />
                    Change Transaction Pin
                  </span>
                ),
                children: (
              <Card
                style={{
                  background: "#F9FCF9",
                  borderRadius: "12px",
                  padding: 30,
                  boxShadow:
                    "0 10px 15px -3px rgb(0, 0, 0, 0.1), 0 4px 6px -4px rgb(0, 0, 0, 0.1)",
                  width: "100%",
                }}
                className="card-key"
              >
                <Form
                  onFinish={() => onFinish(state)}
                  labelCol={{ span: 24 }}
                  layout="vertical"
                  fields={[
                    {
                      name: "pin",
                      value: state?.changePin?.pin,
                    },
                    {
                      name: "confirmPin",
                      value: state?.changePin?.confirmPin,
                    },
                    {
                      name: "oldPin",
                      value: state?.changePin?.oldPin,
                    },
                  ]}
                >
                  <h1 className="font-bold text-lg text-center py-3 flex items-center justify-center gap-1">
                    Change your 4-digit transaction PIN <AiTwotoneLock />
                  </h1>
                  <Row
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <Col span={24}>
                      <Form.Item
                        label="Old Pin"
                        name="oldPin"
                        rules={[{ required: true }]}
                      >
                        <Input
                          type="password"
                          maxLength={4}
                          onChange={(e) =>
                            SetRequest(state, e.target.value, "oldPin")
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="New Pin"
                        name="pin"
                        rules={[{ required: true }]}
                      >
                        <Input
                          type="password"
                          maxLength={4}
                          onChange={(e) =>
                            SetRequest(state, e.target.value, "pin")
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="Confirm Pin"
                        name="confirmPin"
                        rules={[
                          { required: true },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (!value || getFieldValue("pin") === value) {
                                return Promise.resolve();
                              }
                              return Promise.reject(
                                new Error(
                                  "no match!"
                                )
                              );
                            },
                          }),
                        ]}
                      >
                        <Input
                          type="password"
                          maxLength={4}
                          onChange={(e) =>
                            SetRequest(state, e.target.value, "confirmPin")
                          }
                        />
                      </Form.Item>
                    </Col>
                  </Row>
  
                  <p
                    className="mt-[-10px] flex justify-center items-start"
                    style={{ textAlign: "center", width: "100%" }}
                  >
                    Can't remember you pin? &nbsp;
                    <span onClick={() => ResetPin()} style={{ color: "green", cursor: "pointer" }}>
                      Reset pin
                    </span>
                  </p>
                  <Button
                    htmlType="submit"
                    style={{
                      color: "white",
                      backgroundColor: "green",
                    }}
                    className="px-10 py-4 w-[5%] float-right rounded-md md:mt-5 md:w-full flex items-center justify-center"
                    type="link"
                    loading={api.loading}
                  >
                    Submit
                  </Button>
                </Form>
              </Card>
                ),
              },
            ]}
          />
        </div>
      </MerchantLayoutContainer>
    );
  };
  
  export default UserSettings;